import React from 'react';
import classnames from 'classnames';
import { connect } from "react-redux";
import ReactTooltip from 'react-tooltip';
import _ from 'lodash';

import { FormGroup } from 'components/FormElements';
import Translate from 'util/IntlMessages';
import { toggleAlertError, toggleLoading } from 'stores/actions';
import { injectIntl } from "react-intl";

const DisabledInput = ( { children } ) => (
  <div style={{ padding: '6.5px 10px', backgroundColor: '#F0F0F0' }}>{children}</div>
)

class ClientFolderHeader extends React.Component {
  constructor( props ) {
    super( props );

    this.state = {
      accountData: {},
      activeAccount: _.find( _.get( props.channel, 'accounts', [] ), {active: true, account: this.props.activeAccount.account } ),
    };


    this.getData = this.getData.bind( this );
  }

  componentDidMount() {
    this.getData()
  }

  getData() {
    const { activeAccount } = this.state;
    if( !activeAccount ) return;

    const { toggleLoading } = this.props;
    toggleLoading( true );
    this.setState( {
      accountData: _.get(this.props.channel, 'accounts[0].incmsDataobj', {} ),
    } )
    toggleLoading( false );
  }

  render() {
    const {
      accountData, activeAccount
    } = this.state;
    

    return (
      
        <div style={{ boxShadow: 'rgba(0, 0, 0, 0.12) 0px 1px 12px' }}>
          <div className="row align-items-center mx-0">
            <div className="col-md">
              <h5>
                <Translate id="clientFolder"/>
              </h5>
            </div>
            <div className="col-md-auto d-flex align-items-center">
              {_.map( _.get( accountData, 'Tags' ), ( tag, index ) =>
                <span key={index}
                      className={classnames( 'badge text-white text-uppercase ml-2 py-2', {
                        'badge-success': !!tag.Enabled,
                        'badge-secondary': !tag.Enabled,
                      } )}>
                  <span data-tip={tag.Tooltip} data-for={( index + 10 ).toString()}>{tag.Text}</span>
                  <ReactTooltip id={( index + 10 ).toString()} place="bottom" type="dark" effect="solid"/>
                </span>
              )}
            </div>
          </div>
          <div className="row mx-0">
            <div className="col-md-12">
              <div className="row">
                <div className="col-md-3">
                  <FormGroup>
                    <label>
                      <Translate id="name"/>
                    </label>
                    <DisabledInput>
                      {_.get( accountData, 'fullName', '-' )}
                    </DisabledInput>
                  </FormGroup>
                </div>
                <div className="col-md-3">
                  <FormGroup>
                    <label>
                      <Translate id="dni"/>
                    </label>
                    <DisabledInput>
                      {_.get( accountData, 'docNumber', '-' )}
                    </DisabledInput>
                  </FormGroup>
                </div>
                <div className="col-md-6">
                  <FormGroup>
                    <label>
                      <Translate id="address"/>
                    </label>
                    <DisabledInput>
                      {_.get( accountData, 'location', '-' )}
                    </DisabledInput>
                  </FormGroup>
                </div>
              </div>
              <div className="row">
              <div className="col-md-2">
                  <FormGroup>
                    <label>
                      <Translate id="account"/>
                    </label>
                    <DisabledInput>
                      { activeAccount.account }
                    </DisabledInput>
                  </FormGroup>
                </div>
                <div className="col-md-2">
                  <FormGroup>
                    <label>
                      <Translate id="office"/>
                    </label>
                    <DisabledInput>
                      {_.get( accountData, 'officeName', '-' )}
                    </DisabledInput>
                  </FormGroup>
                </div>
                <div className="col-md-2">
                  <FormGroup>
                    <label>
                      <Translate id="phone"/>
                    </label>
                    <DisabledInput>
                      {_.get( accountData, 'phone', '-' )}
                    </DisabledInput>
                  </FormGroup>
                </div>
                <div className="col-md-3">
                  <FormGroup>
                    <label>
                      <Translate id="email"/>
                    </label>
                    <DisabledInput>
                      {_.get( accountData, 'email', '-' ) !== '' ? _.get( accountData, 'email', '-' ) : '-'}
                    </DisabledInput>
                  </FormGroup>
                </div>
                <div className="col-md-3">
                  <FormGroup>
                    <label>
                      <Translate id="supAddress"/>
                    </label>
                    <DisabledInput>
                      {_.get( accountData, 'supplyLocation', '-' )}
                    </DisabledInput>
                  </FormGroup>
                </div>
              </div>
            </div>
          </div>
        </div>
      
    )
  }
}

const mapStateToProps = ( state ) => ( {
  locale: state.settings.locale,
  dateFormat: state.settings.dateFormat,
  externalCodes: state.settings.externalCodes,
  externalCustomer: state.settings.externalCustomer,
  activeAccount: state.channelDetail.activeAccount,
} );

const mapDispatchToProps = dispatch => ( {
  toggleAlertError: ( message ) => {
    dispatch( toggleAlertError( message ) );
  },
  toggleLoading: ( isLoading ) => {
    dispatch( toggleLoading( isLoading ) );
  },
} );
export default injectIntl( connect( mapStateToProps, mapDispatchToProps )( ClientFolderHeader ) );



// WEBPACK FOOTER //
// ./routes/app/components/Agent/ClientFolderHeader/index.js